<section
  class="hero-default"
  [class.hero-default--viewport]="layout() === 'vertical_90vh'"
  [class.theme-dark]="theme() === 'dark'"
  [class.theme-light]="theme() === 'light'"
  [appStoryblok]="_editable()"
  [style.background-color]="backgroundColor() || null"
>
  @if (backgroundGradientImage()) {
    <div
      class="hero-default__gradient"
      aria-hidden="true"
      [style.background-image]="backgroundGradientImage()"
      [style.background-size]="backgroundGradientSize()"
      [style.background-position]="backgroundGradientPosition()"
    ></div>
  }

  @if (gridType() !== 'none') {
    <canvas
      #gridCanvas
      class="hero-default__grid"
      [class.hero-default__grid--below]="gridPosition() === 'below'"
      aria-hidden="true"
      [style.opacity]="gridLayerOpacity()"
    ></canvas>
  }

  <div class="hero-default__stage">
    @if (blurSrc()) {
      <div
        class="hero-default__blur"
        [class.hero-default__blur--top]="blurPosition() === 'top'"
        aria-hidden="true"
        [style.background-image]="'url(&quot;' + blurSrc() + '&quot;)'"
      ></div>
    }

    @if (content()?.length) {
      <div class="hero-default__copy">
        @for (blok of content(); track blok._uid) {
          <ndc-dynamic
            [ndcDynamicComponent]="$any(components[blok.component])"
            [ndcDynamicInputs]="$any(blok)"
          ></ndc-dynamic>
        }
      </div>
    }
  </div>

  @if (showVideo() && desktopSrc()) {
    <div class="hero-default__video">
      <div class="hero-default__video-inner">
        <video
          autoplay
          loop
          muted
          [muted]="true"
          playsinline
          crossorigin="anonymous"
          [controls]="false"
          disablepictureinpicture="true"
          [attr.width]="resolvedVideoWidth()"
          [attr.height]="resolvedVideoHeight()"
          [poster]="videoPoster()"
        >
          @if (mobileOptimizedSrc()) {
            <source media="(max-width: 899px)" [type]="optimizedType" [src]="mobileOptimizedSrc()" />
          }
          @if (mobileSrc()) {
            <source media="(max-width: 899px)" [type]="fallbackType" [src]="mobileSrc()" />
          }
          @if (desktopOptimizedSrc()) {
            <source [type]="optimizedType" [src]="desktopOptimizedSrc()" />
          }
          <source [type]="fallbackType" [src]="desktopSrc()" />
          @for (track of tracks(); track track._uid; let first = $first) {
            <track
              [attr.kind]="track.kind"
              [attr.src]="track['src']"
              [attr.srclang]="srclang()"
              [attr.default]="first ? '' : null"
            />
          }
        </video>
      </div>
    </div>
  }
</section>
